import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD,
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID,
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_FAILURE,
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_SUCCESS,

    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE,
    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_SUCCESS,
    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_FAILURE,

    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE,
    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_SUCCESS,
    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_FAILURE,

    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE,
    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_SUCCESS,
    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_FAILURE,

    ACTION_PROJECTITEMTEMPLATECATEGORY_CLEAR,
    ACTION_PROJECTITEMTEMPLATECATEGORY_FILTER,

    ProjectItemTemplateCategoryAction
} from '../actions/projectItemTemplateCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IProjectItemTemplateCategoryState {
    formData: Dtos.ProjectItemTemplateCategory | Dtos.ProjectItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.ProjectItemTemplateCategory[];
}

const initialState: IProjectItemTemplateCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: IProjectItemTemplateCategoryState, _isLoading: boolean): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IProjectItemTemplateCategoryState,
    formData: Dtos.ProjectItemTemplateCategory | Dtos.ProjectItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IProjectItemTemplateCategoryState, formFilter: IFormFilter): IProjectItemTemplateCategoryState {

    const projectItemTemplateCategorys: Dtos.ProjectItemTemplateCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = projectItemTemplateCategorys ? projectItemTemplateCategorys.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IProjectItemTemplateCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IProjectItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IProjectItemTemplateCategoryState, propertiesToClear?: string[]): IProjectItemTemplateCategoryState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IProjectItemTemplateCategoryState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IProjectItemTemplateCategoryState, _isSaving: boolean): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IProjectItemTemplateCategoryState,
    formData: Dtos.ProjectItemTemplateCategory | Dtos.ProjectItemTemplateCategory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IProjectItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IProjectItemTemplateCategoryState, _isCreating: boolean): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IProjectItemTemplateCategoryState,
    formData: Dtos.ProjectItemTemplateCategory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IProjectItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IProjectItemTemplateCategoryState, _isValidating: boolean): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IProjectItemTemplateCategoryState,
    formData: Dtos.ProjectItemTemplateCategory,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IProjectItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryState {
    const newState: IProjectItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const ProjectItemTemplateCategoryReducer: Reducer<IProjectItemTemplateCategoryState> = (state: IProjectItemTemplateCategoryState = initialState, action: ProjectItemTemplateCategoryAction) => {
    switch (action.type) {
        case ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD:
        case ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE:
            return saving(state, true);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE:
            return creating(state, true);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE:
            return validating(state, true);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_PROJECTITEMTEMPLATECATEGORY_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default ProjectItemTemplateCategoryReducer;